import { Box } from '@mui/material';
import React from 'react';
import { ChangedByCellProps } from '../../modules/tools/models/tools.types';

export const ColumnWithBackground = React.memo(
  ({ params }: ChangedByCellProps) => {
    const isOdd = params.api.getRowIndex(params.id) % 2 !== 0;

    return (
      <Box
        sx={{
          backgroundColor: isOdd ? '#E7EBEE' : '#EEF0F2',
        }}
        className="flex w-full h-full text-xs px-2 items-center whitespace-normal leading-[1.2em] text-left break-words overflow-hidden [display:-webkit-box] [-webkit-line-clamp:3] [-webkit-box-orient:vertical]"
        dangerouslySetInnerHTML={{
          __html: `${params.value || ''}`,
        }}
      />
    );
  }
);
